module.exports = __webpack_public_path__ + "img/logo.f15e8d35.png";